export { default as ClaimNoteSlot } from './ClaimNoteSlot';
